module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/addexchangetrade/addexchangetrade.component.css
// module id = ./src/app/addexchangetrade/addexchangetrade.component.css
// module chunks = main